import { render, staticRenderFns } from "./TextStep.vue?vue&type=template&id=0600b616&scoped=true"
import script from "./TextStep.vue?vue&type=script&lang=ts"
export * from "./TextStep.vue?vue&type=script&lang=ts"
import style0 from "./TextStep.vue?vue&type=style&index=0&id=0600b616&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0600b616",
  null
  
)

export default component.exports